import React from 'react';
import { Edit3, X } from 'lucide-react';
import { SmallText } from '../../../components/brand/BrandTypography';
import { IconButton, PrimaryButton, TertiaryButton } from '../../../components/brand/BrandButton';

const CheckinTab = ({ checkinQuestions, safetyQuestions, editingCheckin, setEditingCheckin, onSave }) => {
    return (
        <div className="space-y-4">
            <div className="mb-4 p-4 bg-[#7D8E95]/20 rounded-xl border border-[#7D8E95]/20">
                <SmallText className="text-[#7D8E95]">
                    <strong>Relationship Check-in Questions</strong> - Click on any question to edit it. Questions to help users identify patterns and get recommendations.
                </SmallText>
            </div>
            <div className="space-y-4">
                {checkinQuestions.map((question, index) => (
                    <div 
                        key={question.question_id} 
                        className="bg-white rounded-xl border border-[#FFBB98] p-4 cursor-pointer hover:border-[#7D8E95]/50 transition-colors"
                        onClick={() => setEditingCheckin({...question})}
                    >
                        <div className="flex items-start gap-3">
                            <span className="w-6 h-6 rounded-full bg-[#7D8E95]/20 text-[#7D8E95] text-sm flex items-center justify-center flex-shrink-0">
                                {index + 1}
                            </span>
                            <div className="flex-1">
                                <p className="font-medium text-[#1D6B6B] mb-1">{question.question}</p>
                                <p className="text-xs text-[#7D8E95] mb-3">{question.subtext}</p>
                                <div className="flex flex-wrap gap-2">
                                    {question.options?.map(opt => (
                                        <span 
                                            key={opt.value} 
                                            className={`px-2 py-1 text-xs rounded-full ${opt.color || 'bg-[#FFBB98]'} text-[#1D6B6B]`}
                                        >
                                            {opt.label}
                                        </span>
                                    ))}
                                </div>
                            </div>
                            <Edit3 className="w-4 h-4 text-[#7D8E95] flex-shrink-0" />
                        </div>
                    </div>
                ))}
            </div>
            
            {editingCheckin && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto p-6">
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="text-lg font-medium">Edit Check-in Question</h3>
                            <IconButton onClick={() => setEditingCheckin(null)}>
                                <X className="w-5 h-5" />
                            </IconButton>
                        </div>
                        <div className="space-y-4">
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Question</label>
                                <textarea 
                                    value={editingCheckin.question} 
                                    onChange={(e) => setEditingCheckin({...editingCheckin, question: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                    rows={2}
                                />
                            </div>
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Subtext</label>
                                <input 
                                    value={editingCheckin.subtext || ''} 
                                    onChange={(e) => setEditingCheckin({...editingCheckin, subtext: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                />
                            </div>
                        </div>
                        <div className="flex gap-3 mt-6">
                            <TertiaryButton onClick={() => setEditingCheckin(null)} className="flex-1">Cancel</TertiaryButton>
                            <PrimaryButton onClick={() => onSave(editingCheckin)} className="flex-1">Save</PrimaryButton>
                        </div>
                    </div>
                </div>
            )}
            
            {/* Safety Questions */}
            <div className="mt-8">
                <h3 className="text-sm font-medium text-[#7D8E95] uppercase tracking-wider mb-3">
                    Safety Check Questions ({safetyQuestions.length})
                </h3>
                <div className="space-y-3">
                    {safetyQuestions.map((question, index) => (
                        <div key={question.question_id} className="bg-white rounded-xl border border-[#FFBB98] p-4">
                            <div className="flex items-start gap-3">
                                <span className="w-6 h-6 rounded-full bg-[#FFBB98]/20 text-[#FFBB98] text-sm flex items-center justify-center flex-shrink-0">
                                    {index + 1}
                                </span>
                                <div className="flex-1">
                                    <p className="font-medium text-[#1D6B6B] mb-1">{question.question}</p>
                                    {question.subtext && <p className="text-xs text-[#7D8E95]">{question.subtext}</p>}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CheckinTab;
